import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: Array<{ value: string; label: string; disabled?: boolean }>
  placeholder?: string
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, options, placeholder, ...props }, ref) => {
    return (
      <div className="relative">
        <select
          ref={ref}
          className={cn(
            'flex h-9 w-full appearance-none rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-xs transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 pr-8',
            className
          )}
          {...props}
        >
          {/*
            Native <option>s inherit a transparent background by default,
            which over the browser's popup surface produces a "washed
            out" look — especially in dark mode where the OS popup tends
            to be light. Setting background + foreground colors explicitly on
            each <option> picks up the popover surface from the theme
            and gives the dropdown the same contrast as any other
            popover surface in the app. Works on Chromium + Firefox;
            Safari respects color but only some shades of background —
            the fallback there is still better than transparent.
          */}
          {placeholder && (
            <option value="" disabled className="bg-popover text-muted-foreground">
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              className="bg-popover text-popover-foreground"
            >
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50 pointer-events-none" />
      </div>
    )
  }
)
Select.displayName = 'Select'

export { Select }
